import { Component } from 'vue-property-decorator';
import BasePage from '@/pages/base-page';
import { Page } from '../../helpers/components';
import { apartmentDetailData } from './apartment-detail.data';
import { WmsLayout } from '../../components/layout/layout';

@Page(WmsLayout, apartmentDetailData) @Component
export class ApartmentDetailPage extends BasePage {
}

export default ApartmentDetailPage;
